import Select, { components } from "react-select";
import styles from "./selectDropdown.module.scss";

interface IProps {
  options: {label: string | number, value: string | number}[];
  label: string;
  handleChange: (option: { value: string | number; label: string }) => void;
  selectValue: string | number;
  isDisabled?: boolean;
}

function SelectDropdown({
  options, label, handleChange, selectValue, isDisabled = false,
}: IProps) {
  const dropdownStyles = {
    menuPortal: (base: any) => ({ ...base, zIndex: 9999 }),
  };

  return (
    <div className={styles.dropdown_container}>
      <Select
        // Passing label to control component
        label={label}
        key={`select_key__${selectValue}`}
        menuPortalTarget={document.body}
        value={selectValue ? {
          value: selectValue,
          label: selectValue,
        } : undefined}
        options={options}
        components={{ Control, IndicatorSeparator: null }}
        placeholder=""
        styles={dropdownStyles}
        theme={(theme) => ({
          ...theme,
          colors: {
            ...theme.colors,
            primary25: "#E0E0E0",
            primary: "#9e9e9e",
            primary50: "#E0E0E0",
          },
        })}
        isClearable={false}
        isSearchable={false}
        onChange={handleChange}
        isDisabled={isDisabled}
      />
    </div>
  );
}

function Control(props: any) {
  const { isFocused, hasValue, selectProps } = props;
  const isFloating = isFocused || hasValue;

  return (
    <>
      <label
        className={`${styles.dropdown_label} ${
          isFloating ? styles.dropdown_label_floating : ""
        }`}
      >
        {selectProps.label}
      </label>
      <components.Control {...props} />
    </>
  );
}

export default SelectDropdown;
